import { z } from 'zod';
/**
 * The list of job titles (תפקיד) a person can be given (owner, 2026-09-19,
 * story 38): a pick from a list rather than free text, so the same job is
 * not spelled five ways across the roster. The list grows from use — a title
 * typed on "add soldier", "edit" or a registration approval is remembered —
 * and never shrinks from here.
 *
 * One document, `settings/titles`, server-only like the rest of `settings`.
 */
export const titleSchema = z.string().trim().min(1).max(80);
export const titlesResponseSchema = z.object({ titles: z.array(titleSchema) });
//# sourceMappingURL=titles.js.map